@if (hide_iframe) {
  <img
    class="screenshot-image"
    [attr.src]="screen_shot"
    (error)="reveal_iframe()"
    />
} @else {
  <div class="iframe-container">
    <div class="disable-iframe"></div>
    @if (fallback_iframe) {
      <iframe
        [src]="iframe_url"
        tabindex="-1"
        scrolling="no"
        allowfullscreen
        sandbox="allow-scripts allow-same-origin"
      ></iframe>
    } @else {
      <mat-spinner
        class="info-spinner"
        mode="indeterminate"
        color="accent"
      ></mat-spinner>
    }
  </div>
}


